module.exports = __webpack_public_path__ + "static/media/img_new01@2x_en.91c8cfec.png";